module.exports = __webpack_public_path__ + "img/loader.77f2d56a.gif";